import React from 'react';
import logoImage from './components/LOGO_green.png';
import './Logo.css';

export default function Logo({ size = 'medium' }) {
  return (
    <div className={`logo logo-${size}`}>
      <img 
        src={logoImage} 
        alt="Логотип школы" 
        className="logo-image"
      />
    </div>
  );
}

